import { useI18n } from '../i18n';
import { PrivacyBody } from '../components/LegalContent';
import { LangSwitcher } from '../components/LangSwitcher';

/**
 * Standalone privacy page at /:locale/privacy (and unprefixed /privacy
 * as a fallback for the App Store / Play Store listing URL — stores
 * want a stable, public URL that doesn't 404 if the user lands without
 * a locale prefix).
 *
 * Renders the same `PrivacyBody` as the LegalModal so there's a single
 * source of truth for the text. Adds a thin page chrome (back link to
 * landing, a footer cross-link to /terms + /account/delete) so the URL
 * is usable as a standalone destination, not just a modal-in-disguise.
 */
export function Privacy() {
  const { t, localePath } = useI18n();
  return (
    <main class="legal-page">
      <div class="legal-page__shell">
        <div class="legal-page__top">
          <a class="legal-page__back" href={localePath('/')}>← BeerCup</a>
          <LangSwitcher theme="light" />
        </div>
        <h1 class="legal-page__title">{t('legal.privacy_title')}</h1>
        <div class="legal-page__body">
          <PrivacyBody />
        </div>
        <nav class="legal-page__nav" aria-label="legal pages">
          <a href={localePath('/terms')}>{t('legal.terms_title')}</a>
          <span>·</span>
          <a href={localePath('/support')}>{t('support.title')}</a>
          <span>·</span>
          <a href={localePath('/account/delete')}>{t('account.delete.title')}</a>
        </nav>
      </div>
    </main>
  );
}
